import type { IListItem } from "@monta/design-system";
import { ContentType, SeriesEnum } from "./packages";

export enum LocalSortTypesEnum {
  DEMO_COUNT = 1,
  SALES_COUNT = 2,
  PRODUCT_VIEW_NO = 3,
  CREATED_AT = 4,
}
export const localSortTypes = [
  { id: LocalSortTypesEnum.DEMO_COUNT, label: "محبوب‌ترین" },
  { id: LocalSortTypesEnum.SALES_COUNT, label: "پرفروش‌ترین" },
  { id: LocalSortTypesEnum.PRODUCT_VIEW_NO, label: "پربازدیدترین" },
  { id: LocalSortTypesEnum.CREATED_AT, label: "جدیدترین" },
];

export enum FilterTypeEnum {
  GRADE_MAJOR = "gradeMajor",
  SERI = "seri",
  MODULE_GROUP = "moduleGroup",
  CONTENT_TYPE = "contentType",
  SEARCH = "search",
  LEVEL = "level",
}

export const gradeMajorfilter: IListItem[] = [
  { id: "12-60", label: "دوازدهم ریاضی" },
  { id: "12-61", label: "دوازدهم تجربی" },
  { id: "12-62", label: "دوازدهم انسانی" },
  { id: "11-60", label: "یازدهم ریاضی" },
  { id: "11-61", label: "یازدهم تجربی" },
  { id: "11-62", label: "یازدهم انسانی" },
  { id: "10-60", label: "دهم ریاضی" },
  { id: "10-61", label: "دهم تجربی" },
  { id: "10-62", label: "دهم انسانی" },
  { id: "9-56", label: "نهم" },
  { id: "8-56", label: "هشتم" },
  { id: "7-56", label: "هفتم" },
  { id: "6-53", label: "ششم" },
  { id: "5-53", label: "پنجم" },
  { id: "3-53", label: "چهارم" },
];

export const levelsfilter: IListItem[] = [
  { id: "60", label: "دوره دوم متوسطه" },
  { id: "50", label: "دوره اول متوسطه" },
  { id: "20", label: "دوره دبستان" },
];

export const serifilter: IListItem[] = [
  // { id: String(SeriesEnum.NOROUZ_LEAGUE), label: 'ليگ نوروزي' },
  // { id: String(SeriesEnum.SMART_TUTOR), label: 'معلم خصوصی هوشمند' },
  // {
  //   id: String(SeriesEnum.SIXTH_GRADE_VIP_TIZHOSHAN_EXAM),
  //   label: 'سری ویژه آزمون تیزهوشان ششم',
  // },
  { id: String(SeriesEnum.GENERAL), label: "جامع" },
  {
    id: String(SeriesEnum.KONKOUR_SIMULATOR_1402),
    label: "شبیه ساز کنکور ۱۴۰۲",
  },
  // {
  //   id: String(SeriesEnum.KONKOUR_SIMULATOR_1403),
  //   label: 'شبیه ساز کنکور ۱۴۰۳',
  // },
];
export const contentTypeFilter: IListItem[] = [
  { id: String(ContentType.PRACTICE), label: "تمرین" },
  { id: String(ContentType.LECTURE), label: "درسنامه" },
  { id: String(ContentType.EXAM), label: "آزمون" },
  { id: String(ContentType.VIDEO), label: "ویدیو" },
  { id: String(ContentType.PDF), label: "پی دی اف" },
  { id: String(ContentType.VOICE), label: "صوت" },
  { id: String(ContentType.DESCRIPTIVE_PRACTICE), label: "تکلیف تشریحی" },
];

export enum ProductTypesEnum {
  BANKB2C = 2,
  EDUCATION_PACK = 11,
}
